import { atom } from 'jotai';

// Open state of the single-product hero's "Détails du panier" drawer. Lifted to
// a shared atom so the sticky Header toggle can drive the drawer that the
// MobileCartSummary hero renders below it.
export const cartDetailsDrawerOpenAtom = atom<boolean>(false);
